import { useContext, useEffect, useState } from "react";
import client from "../../../contentfulClient";
import "./LanguageCourses.scss";
import { MainContext } from "../../../MainContext";
import useScrollAnimation from "../../useAnimationScrolling";

export const LanguageCourses = () => {
	const {
		courses,
		staticTexts: { courses: staticTexts },
		languageCoursesRef,
    } = useContext(MainContext);
    
    const animationConfig = {
		scale: [0, 1],
		opacity: [0, 1],
		duration: 1000,
		easing: "easeOutExpo",
	};

	useScrollAnimation(languageCoursesRef, animationConfig, courses);

	return (
		<div className="courses-container">
			<p className="header">{staticTexts.title}</p>

			<div className="courses">
				{courses.map((course: any, index: number) => {
					const isBig = !course.title;

					return (
						<div
							style={{ backgroundImage: `url(${course.image})` }}
							className={`course-card ${isBig ? "big-block" : "small-block"}`}
							ref={(el) => {
								if (el) languageCoursesRef.current[index] = el;
							}}
							key={index}
						>
							{!isBig && (
								<div className="container">
									<h3 className="title">{course.title}</h3>
									<p className="courses-description">{course.subTitle}</p>
								</div>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
};
